import { forwardRef, type ComponentPropsWithoutRef, type ElementRef, type ReactNode } from "react";
import * as RxTooltip from "@radix-ui/react-tooltip";
import { cn } from "@/lib/cn";

export const TooltipProvider = ({ children }: { children: ReactNode }) => (
  <RxTooltip.Provider delayDuration={300} skipDelayDuration={100}>
    {children}
  </RxTooltip.Provider>
);

const Content = forwardRef<
  ElementRef<typeof RxTooltip.Content>,
  ComponentPropsWithoutRef<typeof RxTooltip.Content>
>(({ className, sideOffset = 6, ...props }, ref) => (
  <RxTooltip.Content
    ref={ref}
    sideOffset={sideOffset}
    className={cn(
      "z-50 rounded-[var(--radius-sm)] bg-fg px-2 py-1 text-xs text-canvas shadow-[var(--shadow-2)]",
      "data-[state=delayed-open]:animate-in data-[state=delayed-open]:fade-in-0 data-[state=delayed-open]:zoom-in-95",
      className,
    )}
    {...props}
  />
));
Content.displayName = "Tooltip.Content";

export const Tooltip = {
  Root: RxTooltip.Root,
  Trigger: RxTooltip.Trigger,
  Content,
  Portal: RxTooltip.Portal,
};
